import orderCreateComponent from './components/order.create.component';
import orderCreateTabsComponent from './components/order.create.tabs.component';

import orderCreateController from './controllers/order.create.controller';
import orderCreateTabsController from './controllers/order.create.tabs.controller';

let orderCreationModule = angular.module('spabooker.order.create', ['spabooker.base'])
    .component('orderCreate', orderCreateComponent)
    .component('orderCreateTabs', orderCreateTabsComponent)

    .controller('orderCreateController', orderCreateController)
    .controller('orderCreateTabsController', orderCreateTabsController)

    .run(['configService', 'paymentGatewayService', (configService, paymentGatewayService) => {
        const config = configService.get('gateways');

        if (paymentGatewayService && config) {
            paymentGatewayService.load(config);
        }
    }])
    ;

export default orderCreationModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/orderCreation/index.js